/* ---------- 13. carousel loader: fetch dist/theapp-carousel.js (Swiper) only on pages that have a slider ---------- */

import { BUNDLE } from '../lib/bundle';
import { $ } from '../lib/dom';
import { error } from '../lib/log';

export const SLIDER = '[data-slider-instance]';
export const CAROUSEL_FILE = 'theapp-carousel.js';

/** Swiper is ~27 KB gzip — four times this bundle — and 498 of 783 pages have no slider, so it ships as its own file.
 *  Injected scripts run async; theapp-carousel.js boots itself through the Webflow queue (src/carousel.ts). */
export const loadCarousel = () => {
  if (!$(SLIDER) || $(`script[src*="${CAROUSEL_FILE}"]`)) return;
  const script = document.createElement('script');
  script.src = `${BUNDLE.base}/${CAROUSEL_FILE}${BUNDLE.query}`;
  script.onerror = () => error(`${CAROUSEL_FILE} failed to load from ${BUNDLE.base}`);
  document.head.append(script);
};
